import { RainEvidencePayload } from "../../services/rainApi";

export type EvidenceKind = "file" | "youtube" | "url";

export type EvidenceStatus = "pending" | "analyzing" | "done" | "failed";

export interface WizardEvidenceItem {
  id: string;
  kind: EvidenceKind;
  /** Present when kind === "file" */
  file?: File;
  /** Present when kind === "youtube" | "url" */
  url?: string;
  status: EvidenceStatus;
  error?: string;
  /** Built from the analysis response; what gets submitted with the dispute */
  payload?: RainEvidencePayload;
}

export interface RainFormData {
  question: string;
  options: string[];
  context: string;
  poolCreationDate: string;
  aiDecision: string;
}

export const emptyRainForm: RainFormData = {
  question: "",
  options: ["", ""],
  context: "",
  poolCreationDate: "",
  aiDecision: "",
};
